<template>
    <dt> 
        <label>{{ field.label}}</label>
        <validation-results :validationResults="validationResults" />
    </dt>
    <dd>
        <input v-if="field.maxLength<100" class="form-control" type="text" v-model="proxyValue"  :disabled="disabled"/>
        <textarea v-else class="form-control" v-model="proxyValue" rows="3" cols="80"  :disabled="disabled" ></textarea>
    </dd> 
</template>
 
  
<script lang="ts">
import { Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';  
import {FormLayout, FormField, setProxyValue, FieldValidationResult} from './Forms'; 
import ValidationResults from './ValidationResults.vue';
 
@Options({components:{ValidationResults}})
export default class TextField extends Vue
{ 
   @Prop() public field!: FormField;
   @Prop() public data!: any; 
   @Prop() public validationResults!: FieldValidationResult[];
   @Prop({default:false}) public disabled!: boolean;

   public proxyValue="";

   @Watch("proxyValue")
   public proxyValueChanged()
   {
     this.data[this.field.name] = this.proxyValue;
   }

   public mounted()
   {
     setProxyValue(this);
   }
}
</script>